import { createContext } from "react";

const ExamRoutineContext = createContext();

export default ExamRoutineContext;